module.exports = __webpack_public_path__ + "img/DTIO1.adeee674.png";